/* eslint-disable react/require-default-props */
import React from 'react'
import * as S from './styles'
import { getImage, ImageDataLike } from 'gatsby-plugin-image'
import { StrapiFile } from '@shared/utils/strapi/strapi.types'

export interface ImageCustomProps {
  readonly image?: StrapiFile & { localFile?: ImageDataLike }
  readonly alt: string
  readonly className?: string
}

const ImageCustom: React.FC<ImageCustomProps> = ( { image = null, alt, className = '' } ) => {
  if ( image?.localFile ) {
    const imageLocalFile = getImage( image.localFile )!
    return (
      <S.ImageCustom
        image={ imageLocalFile }
        className={ className }
        alt={ alt }
      />
    )
  }

  return (
    <img
      src={ image!.url }
      className={ className }
      aria-label={ alt }
    />
  )
}

export default ImageCustom
